import { render, staticRenderFns } from "./EmployeeSetting.vue?vue&type=template&id=5943c608&scoped=true&"
import script from "./EmployeeSetting.vue?vue&type=script&lang=js&"
export * from "./EmployeeSetting.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSetting.vue?vue&type=style&index=0&id=5943c608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5943c608",
  null
  
)

export default component.exports